import { useEffect } from "react";
import { Link as RouterLink, Navigate, useParams } from "react-router-dom";
import { alpha, Box, Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
    TOC,
    getSectionById,
    getSectionIndex,
    isValidSectionId,
    docPath,
} from "../../config/documentationContent";
import { DocSection } from "./DocComponents";

export default function DocumentationSectionPage() {
    const { sectionId } = useParams();
    const valid = isValidSectionId(sectionId);

    useEffect(() => {
        if (valid) {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        }
    }, [sectionId, valid]);

    if (!valid) {
        return <Navigate to="/docs/getting-started" replace />;
    }

    const index = getSectionIndex(sectionId);
    const section = getSectionById(sectionId);
    const prev = index > 0 ? TOC[index - 1] : null;
    const next = index < TOC.length - 1 ? TOC[index + 1] : null;

    return (
        <>
            <DocSection section={section} index={index} />
            <Stack
                direction={{ xs: "column", sm: "row" }}
                justifyContent="space-between"
                alignItems={{ xs: "stretch", sm: "center" }}
                spacing={1.5}
                sx={{ mt: 4, pt: 3, borderTop: `1px solid ${alpha("#e8c97e", 0.2)}` }}
            >
                {prev ? (
                    <Button
                        component={RouterLink}
                        to={docPath(prev.id)}
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            justifyContent: { xs: "flex-start", sm: "flex-start" },
                            color: "text.secondary",
                            fontFamily: '"DM Sans", sans-serif',
                            "&:hover": { color: "primary.main", bgcolor: alpha("#e8c97e", 0.06) },
                        }}
                    >
                        <Box component="span" sx={{ textAlign: "left" }}>
                            <Typography variant="caption" display="block" sx={{ color: "text.secondary" }}>
                                Previous
                            </Typography>
                            {prev.label}
                        </Box>
                    </Button>
                ) : (
                    <Box />
                )}
                {next ? (
                    <Button
                        component={RouterLink}
                        to={docPath(next.id)}
                        endIcon={<ArrowForwardIcon />}
                        sx={{
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            color: "text.secondary",
                            fontFamily: '"DM Sans", sans-serif',
                            ml: { sm: "auto" },
                            "&:hover": { color: "primary.main", bgcolor: alpha("#e8c97e", 0.06) },
                        }}
                    >
                        <Box component="span" sx={{ textAlign: { xs: "left", sm: "right" } }}>
                            <Typography variant="caption" display="block" sx={{ color: "text.secondary" }}>
                                Next
                            </Typography>
                            {next.label}
                        </Box>
                    </Button>
                ) : null}
            </Stack>
        </>
    );
}
